var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D2BE0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3364 24.3368C17.0346 24.3368 15.168 22.4702 15.168 20.1684C15.168 17.8666 17.0346 16 19.3364 16C21.639 16 23.5048 17.8666 23.5048 20.1684C23.5048 22.4702 21.639 24.3368 19.3364 24.3368",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4542 21.6951L12.2128 23.3858C11.4759 23.7702 10.613 23.1499 10.7539 22.3337L11.4775 18.1462L8.41127 15.1808C7.81268 14.603 8.14282 13.5959 8.96816 13.4775L13.2049 12.8665L15.0974 9.0532C15.465 8.31039 16.5321 8.31039 16.9015 9.0532L18.7973 12.8665L23.034 13.4759C23.8594 13.5943 24.1878 14.6013 23.5909 15.1791L21.861 16.8523",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1873 19.2422L18.8713 21.5582L17.4824 20.1684",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/SelectIcon.dd4fc47c6631fba82ba43e7cc6ef67c0.svg";
export { ForwardRef as ReactComponent };